// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ycsc","top":"styles_top__3m5bE"};